import React from 'react';
import type { PlayerPublicInfo } from '@shared/types';

interface PlayerSlotProps {
  player: PlayerPublicInfo;
  position: 'top' | 'left' | 'right';
}

export const PlayerSlot = React.memo(function PlayerSlot({ player, position }: PlayerSlotProps) {
  const {
    nickname,
    tileCount,
    totalScore,
    isConnected,
    isDealer,
    isCurrentTurn,
    avatar,
  } = player;

  return (
    <div className={`player-${position}`}>
      <div
        className={[
          'player-panel',
          isCurrentTurn ? 'active-turn' : '',
          !isConnected ? 'disconnected' : '',
        ]
          .filter(Boolean)
          .join(' ')}
      >
        <div className={`player-avatar${!isConnected ? ' offline' : ''}`}>
          {avatar}
          {isDealer && (
            <span className="dealer-badge" title="Dağıtıcı">
              D
            </span>
          )}
        </div>

        <div className="player-name" title={nickname}>
          {nickname}
        </div>

        <div className="player-score">{totalScore}</div>

        {/* Mini tiles showing opponent's tile count */}
        <div className="opponent-tiles-mini">
          {Array.from({ length: Math.min(tileCount, 14) }).map((_, i) => (
            <div key={i} className="opp-tile-mini" />
          ))}
        </div>

        {/* Active turn glow ring */}
        {isCurrentTurn && (
          <div
            style={{
              position: 'absolute',
              inset: -3,
              borderRadius: 'var(--radius-md)',
              border: '2px solid var(--gold)',
              pointerEvents: 'none',
              animation: 'pulse-gold 2s infinite',
            }}
          />
        )}
      </div>
    </div>
  );
});

export default PlayerSlot;
